$(function () {
  let section = $('#cuenta-eventos')
  if (section.get(0) == null) {
    return
  }

  let vueApp = new Vue({
    el: section.get(0),
    data: {
      filtros: {page: 1, last_page: 1},
      eventos: [],
      loader: false
    },
    mounted() {
      this.getEventos()
    },
    methods: {
      nextPagina(){
        if(this.filtros.page < this.filtros.last_page){
          this.filtros.page += 1
          this.getEventos()
        }
      },
      getEventos(){
        if (this.loader) {
          return
        }
        this.loader = true
        axios
          .get('/eventos-json', {
            params: this.filtros,
          })
          .then((respuesta) => {
            vueApp.loader = false
            if (respuesta.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            vueApp.filtros.last_page = respuesta.data.eventos.last_page
            vueApp.eventos = [...vueApp.eventos,...respuesta.data.eventos.data]
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueApp.loader = false
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      }
    }
  });
});
